import * as THREE from 'three';
import { Voxel } from "./Voxel";
function between(min, val, max) {
    return val >= min && val <= max;
}
export default class VoxelGrid extends THREE.Object3D {
    constructor() {
        super();
        this.wholeSphere = false;
        this.voxels = new Array();
    }
    get size() { return this._size; }
    get speed() { return this._speed; }
    anyCorner(predicate) {
        return predicate(this._corners[0]) || predicate(this._corners[1])
            || predicate(this._corners[2]) || predicate(this._corners[3])
            || predicate(this._corners[4]) || predicate(this._corners[5])
            || predicate(this._corners[6]) || predicate(this._corners[7]);
    }
    calcDistance(from, to) {
        const vec = new THREE.Vector3().copy(to.sub(from));
        vec.set(Math.abs(vec.x), Math.abs(vec.y), Math.abs(vec.z));
        var distance = 0;
        if (vec.x >= vec.y && vec.x >= vec.z) {
            distance = vec.x + (vec.y >> 1) + (vec.z >> 1);
            console.log(`Vec(${vec.x},${vec.y},${vec.y}): X, ${distance}`);
        }
        else if (vec.y >= vec.x && vec.y >= vec.z) {
            distance = vec.y + (vec.x >> 1) + (vec.z >> 1);
            console.log(`Vec(${vec.x},${vec.y},${vec.y}): Y, ${distance}`);
        }
        else {
            distance = vec.z + (vec.x >> 1) + (vec.y >> 1);
            console.log(`Vec(${vec.x},${vec.y},${vec.y}): Z, ${distance}`);
        }
        return distance;
    }
    fillSize() {
        const size = this._size;
        this.bodyVoxels = Array(size * size * size);
        this._halfSize = size % 2 == 0 ? (size >> 1) - 0.5 : size >> 1;
        const halfSize = this._halfSize;
        const position = new THREE.Vector3();
        var voxel;
        this._corners = [
            new THREE.Vector3(halfSize, halfSize, halfSize),
            new THREE.Vector3(-halfSize, halfSize, halfSize),
            new THREE.Vector3(halfSize, -halfSize, halfSize),
            new THREE.Vector3(-halfSize, -halfSize, halfSize),
            new THREE.Vector3(halfSize, halfSize, -halfSize),
            new THREE.Vector3(-halfSize, halfSize, -halfSize),
            new THREE.Vector3(halfSize, -halfSize, -halfSize),
            new THREE.Vector3(-halfSize, -halfSize, -halfSize)
        ];
        for (var idx = 0; idx < this.bodyVoxels.length; idx++) {
            position.x = Math.trunc(idx % size) - halfSize;
            position.y = Math.trunc(Math.trunc(idx / size) % size);
            position.z = Math.trunc(Math.trunc(idx / size) / size) - halfSize;
            voxel = new Voxel();
            voxel.state = Voxel.State.Filled;
            voxel.position.copy(position);
            this.bodyVoxels[idx] = voxel;
            this.add(voxel);
        }
    }
    fillSphere() {
        const size = this._size;
        const speed = this._speed;
        const volumeDim = (speed * 2) + size;
        const invVolumeDim = 1 / volumeDim;
        const halfDim = volumeDim % 2 == 0 ? (volumeDim >> 1) - 0.5 : volumeDim >> 1;
        const voxelCount = volumeDim * volumeDim * volumeDim;
        const position = new THREE.Vector3();
        var betweenX;
        var betweenY;
        var betweenZ;
        var voxel;
        const processor = (value) => {
            return this.calcDistance(value, position) <= speed;
            // return Math.round(position.distanceTo(value) + 0.25) <= speed;
        };
        for (var idx = 0; idx < voxelCount; idx++) {
            if (idx == this.voxels.length)
                this.voxels.push(new Voxel());
            voxel = this.voxels[idx];
            voxel.visible = true;
            position.x = Math.trunc(idx % volumeDim) - halfDim;
            position.y = Math.trunc(Math.trunc(idx * invVolumeDim) % volumeDim) - halfDim;
            position.z = Math.trunc(Math.trunc(idx * invVolumeDim) * invVolumeDim) - halfDim;
            betweenX = between(-this._halfSize, position.x, this._halfSize);
            betweenY = between(-this._halfSize, position.y, this._halfSize);
            betweenZ = between(-this._halfSize, position.z, this._halfSize);
            if (!this.wholeSphere && !between(-0.45, position.y + this.position.y, 0.45))
                continue;
            // if (!this.wholeSphere && position.y != 0) continue;
            /*if (betweenX && (betweenY != betweenZ)
                || betweenY && (betweenX != betweenZ)
                || betweenZ && (betweenY != betweenX)) { }
            else*/ if (this.anyCorner(processor)) { }
            else {
                continue;
            }
            voxel.position.copy(position);
            voxel.position.y += this._halfSize;
            voxel.state = Voxel.State.Valid;
            this.add(voxel);
        }
        // const ringSize = speed// + (size >> 1);
        // const outerRingSq = ringSize * ringSize;
        // const innerRingSq = (ringSize - 1) * (ringSize - 1);
        // speed = size + (speed * 2);
        // const halfSpeed = speed >> 1;
        // for (var idx = 0; idx < voxelCount; idx++) {
        // 	if (idx == this.voxels.length) {
        // 		this.voxels.push(new Voxel());
        // 	}
        // 	voxel = this.voxels[idx];
        // 	voxel.visible = true;
        // 	position.x = Math.trunc(idx % speed) - halfSpeed;
        // 	position.y = Math.trunc(Math.trunc(idx / speed) % speed) - halfSpeed;
        // 	position.z = Math.trunc(Math.trunc(idx / speed) / speed) - halfSpeed;
        // 	voxel.position.copy(position);
        // 	var distance = position.lengthSq()
        // 	if (distance < size) {
        // 		this.add(voxel)
        // 		voxel.state = Voxel.State.Filled;
        // 	} else if (distance <= outerRingSq && ((this.wholeSphere && distance > innerRingSq) || (position.y + this.position.y) == 0)) {
        // 		this.add(voxel)
        // 		voxel.state = Voxel.State.Valid;
        // 	} else {
        // 		this.remove(voxel);
        // 	}
        // }
        // if (voxelCount < this.voxels.length) {
        // 	for (var c: number = voxelCount; c < this.voxels.length; c++) {
        // 		this.voxels[c].visible = false;
        // 	}
        // }
    }
    updateVolume(size, speed) {
        this.clear();
        this._size = size;
        this._speed = speed;
        this.fillSize();
        this.fillSphere();
    }
}
